export default {
  modal: "atom-modal",
  overlay: "atom-overlay",
  header: "atom-header",
  container: "atom-container",
  content: "atom-content",
  containerOpen: "atom-containerOpen",
  input: "atom-input",
  inputOpen: "atom-inputOpen",
  inputFocused: "atom-inputFocused",
  spinner: "atom-spinner",
  suggestionsContainer: "atom-suggestionsContainer",
  suggestionsContainerOpen: "atom-suggestionsContainerOpen",
  suggestionsList: "atom-suggestionsList",
  suggestion: "atom-suggestion",
  suggestionFirst: "atom-suggestionFirst",
  suggestionHighlighted: "atom-suggestionHighlighted",
  trigger: "atom-trigger"
};
